import {
  AdditiveBlending,
  CustomBlending,
  NormalBlending,
  SubtractiveBlending,
  type Blending,
} from "three";

export const mapBlendingMode = (mode: number): Blending => {
  switch (mode) {
    case -1: // BLENDMODE_SUBTRACT
      return SubtractiveBlending;
    case 0: // BLENDMODE_ONEONE
      return AdditiveBlending;
    case 1: // BLENDMODE_STANDARD
      return NormalBlending;
    case 2: // BLENDMODE_ADD
      return CustomBlending;
    case 3: // BLENDMODE_MULTIPLY
    case 4: // BLENDMODE_MULTIPLYADD
    default:
      return NormalBlending;
  }
};
